import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getLocalParticipant } from '../../../base/participants/functions';
import { getHideSelfView } from '../../../base/settings/functions.any';
import { LAYOUTS } from '../../../video-layout/constants';
import { getCurrentLayout } from '../../../video-layout/functions.web';
import { FILMSTRIP_TYPE, TILE_ASPECT_RATIO, TILE_HORIZONTAL_MARGIN } from '../../constants';
import { getActiveParticipantsIds, showGridInVerticalView } from '../../functions.web';
import Thumbnail from './Thumbnail';
import { getCameraActiveParticipants, } from "context/participants/functions";
import { shouldHideCameraOffParticipants } from "context/video-grid/functions";
import { getFakeParticipants, getScreenshareParticipantIds, isScreenShareParticipantById, } from "../../../base/participants/functions";
/**
 * A wrapper Component for the Thumbnail that translates the react-window specific props
 * to the Thumbnail Component's props.
 */
class ThumbnailWrapper extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _disableSelfView, _filmstripType = FILMSTRIP_TYPE.MAIN, _isLocalScreenShare = false, _horizontalOffset = 0, _participantID, _thumbnailWidth, style } = this.props;
        if (typeof _participantID !== 'string') {
            return null;
        }
        if (_participantID === 'local') {
            return _disableSelfView ? null : (React.createElement(Thumbnail, { filmstripType: _filmstripType, horizontalOffset: _horizontalOffset, key: 'local', style: style, width: _thumbnailWidth }));
        }
        if (_isLocalScreenShare) {
            return _disableSelfView ? null : (React.createElement(Thumbnail, { filmstripType: _filmstripType, horizontalOffset: _horizontalOffset, key: 'localScreenShare', participantID: _participantID, style: style, width: _thumbnailWidth }));
        }
        return (React.createElement(Thumbnail, { filmstripType: _filmstripType, horizontalOffset: _horizontalOffset, key: `remote_${_participantID}`, participantID: _participantID, style: style, width: _thumbnailWidth }));
    }
}
function _mapStateToProps(state, ownProps) {
    const _currentLayout = getCurrentLayout(state);
    const { remoteParticipants: remote } = state["features/filmstrip"];
    const disableSelfView = getHideSelfView(state);
    const _verticalViewGrid = showGridInVerticalView(state);
    const filmstripType = ownProps.data?.filmstripType;
    const stageFilmstrip = filmstripType === FILMSTRIP_TYPE.STAGE;
    const activeParticipants = getActiveParticipantsIds(state);
    const sortedActiveParticipants = activeParticipants.sort();
    let remoteParticipants = stageFilmstrip ? sortedActiveParticipants : remote;
    if (shouldHideCameraOffParticipants(state)) {
        const fakeParticipants = getFakeParticipants(state);
        const participantsWithScreenShare = getScreenshareParticipantIds(state);
        const activeUsers = getCameraActiveParticipants(state);
        remoteParticipants = remoteParticipants.filter(participant => {
            if (isScreenShareParticipantById(state, participant))
                return true;
            else if (activeUsers.includes(participant))
                return true;
            return false;
        });
    }
    const remoteParticipantsLength = remoteParticipants.length;
    const localId = getLocalParticipant(state)?.id;
    if (_currentLayout === LAYOUTS.TILE_VIEW || _verticalViewGrid || stageFilmstrip) {
        const { columnIndex, rowIndex } = ownProps;
        const { tileViewDimensions, stageFilmstripDimensions, verticalViewDimensions } = state["features/filmstrip"];
        const { gridView } = verticalViewDimensions;
        let gridDimensions = tileViewDimensions?.gridDimensions, thumbnailSize = tileViewDimensions?.thumbnailSize;
        if (stageFilmstrip) {
            gridDimensions = stageFilmstripDimensions.gridDimensions;
            thumbnailSize = stageFilmstripDimensions.thumbnailSize;
        }
        else if (_verticalViewGrid) {
            gridDimensions = gridView?.gridDimensions;
            thumbnailSize = gridView?.thumbnailSize;
        }
        const { columns = 1, rows = 1 } = gridDimensions ?? {};
        const index = rowIndex * columns + columnIndex;
        let horizontalOffset, thumbnailWidth;
        const { iAmRecorder, disableTileEnlargement } = state["features/base/config"];
        const { localScreenShare } = state["features/base/participants"];
        const localParticipantsLength = localScreenShare ? 2 : 1;
        let participantsLength;
        if (stageFilmstrip) {
            participantsLength = remoteParticipantsLength;
        }
        else {
            participantsLength = remoteParticipantsLength + (disableSelfView ? 0 : localParticipantsLength) - (iAmRecorder ? 1 : 0);
        }
        if (rowIndex === rows - 1) {
            const partialLastRowParticipantsNumber = participantsLength % columns;
            if (partialLastRowParticipantsNumber > 0) {
                const { width = 1, height = 1 } = thumbnailSize ?? {};
                const availableWidth = columns * (width + TILE_HORIZONTAL_MARGIN);
                let widthDifference = 0;
                let widthToUse = width;
                if (!disableTileEnlargement) {
                    thumbnailWidth = Math.min(availableWidth / partialLastRowParticipantsNumber - TILE_HORIZONTAL_MARGIN, height * TILE_ASPECT_RATIO);
                    widthDifference = thumbnailWidth - width;
                    widthToUse = thumbnailWidth;
                }
                horizontalOffset = Math.floor((availableWidth - partialLastRowParticipantsNumber * (widthToUse + TILE_HORIZONTAL_MARGIN)) / 2) + columnIndex * widthDifference;
            }
        }
        if (index > participantsLength - 1) {
            return {};
        }
        if (stageFilmstrip) {
            return {
                _disableSelfView: disableSelfView,
                _filmstripType: filmstripType,
                _participantID: remoteParticipants[index] === localId ? "local" : remoteParticipants[index],
                _horizontalOffset: horizontalOffset,
                _thumbnailWidth: thumbnailWidth
            };
        }
        const localIndex = disableSelfView ? remoteParticipantsLength : 0;
        const localScreenShareIndex = disableSelfView ? remoteParticipantsLength : 1;
        const remoteIndex = !iAmRecorder && !disableSelfView ? index - localParticipantsLength : index;
        if (!iAmRecorder && index === localIndex) {
            return {
                _disableSelfView: disableSelfView,
                _filmstripType: filmstripType,
                _participantID: "local",
                _horizontalOffset: horizontalOffset,
                _thumbnailWidth: thumbnailWidth
            };
        }
        if (!iAmRecorder && localScreenShare && index === localScreenShareIndex) {
            return {
                _disableSelfView: disableSelfView,
                _filmstripType: filmstripType,
                _isLocalScreenShare: true,
                _participantID: localScreenShare?.id,
                _horizontalOffset: horizontalOffset,
                _thumbnailWidth: thumbnailWidth
            };
        }
        return {
            _filmstripType: filmstripType,
            _participantID: remoteParticipants[remoteIndex],
            _horizontalOffset: horizontalOffset,
            _thumbnailWidth: thumbnailWidth
        };
    }
    if (_currentLayout === LAYOUTS.STAGE_FILMSTRIP_VIEW && filmstripType === FILMSTRIP_TYPE.SCREENSHARE) {
        const { screenshareFilmstripParticipantId } = state["features/filmstrip"];
        const screenshares = state["features/video-layout"].remoteScreenShares;
        let id = screenshares.find(sId => sId === screenshareFilmstripParticipantId);
        if (!id && screenshares.length) {
            id = screenshares[screenshares.length - 1];
        }
        return {
            _filmstripType: filmstripType,
            _participantID: id
        };
    }
    const { index } = ownProps;
    if (typeof index !== "number" || remoteParticipantsLength <= index) {
        return {};
    }
    return {
        _participantID: remoteParticipants[index]
    };
}
export default connect(_mapStateToProps)(ThumbnailWrapper);
